function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { useExpertMessageContext } from "../../../../../expert";
import { DialogueNote, FadeUp } from "../../../../../customer/components";
import ExpertAvatar from "./suffixes/ExpertAvatar";
import ExpertReviewSuffix from "./suffixes/ExpertReviewSuffix";
import FailedToSendSuffix from "./suffixes/FailedToSendSuffix";
const SUFFIX_MAP = {
  respond: ExpertAvatar,
  review: ExpertReviewSuffix,
  reviewEscalation: ExpertAvatar,
  reviewDetailed: () => null,
  managerQualityReviewDetailed: () => null
};
const REVIEW_DENY_REVIEW_DIALOGUE_TYPE = ["custConfirmation", "escalation"];
const REVIEW_ALLOW_REIVEW_DIALOGUE_ORIGIN = ["expert"];
const REVIEW_DENY_REVIEW_DIALOGUE_ORIGIN = ["system"];
const QUALITY_REVIEW_CONVERSATION_STATE_TYPES = ["managerQualityReviewDetailed", "reviewDetailed"];
const ExpertDialogueWrapper = ({
  classes,
  shouldAnimate,
  children,
  dialogue,
  message,
  dialogueSuffixMap,
  ...rest
}) => {
  const {
    contentModerated,
    dialogueId
  } = dialogue;
  const {
    dialogueError,
    dialogueNote
  } = useExpertMessageContext();
  const contentModeratedData = contentModerated !== null && contentModerated !== void 0 && contentModerated.action ? {
    action: contentModerated.action,
    reason: contentModerated.action === "masked" ? "We detected unsuitable language in your response and have changed the message accordingly to protect our community. If you believe this to be an error, please contact the Limitless support team." : contentModerated.reason
  } : contentModerated;
  const hasDialogueNote = dialogueNote[dialogueId] || contentModerated && contentModerated.reason ? true : false;
  let ExpertSuffix;
  let ExpertDialogueAction;
  if (dialogueError && dialogueError === dialogueId) {
    ExpertSuffix = FailedToSendSuffix;
  } else if ((REVIEW_DENY_REVIEW_DIALOGUE_ORIGIN.includes(dialogue.origin) || REVIEW_DENY_REVIEW_DIALOGUE_TYPE.includes(dialogue.type)) && !QUALITY_REVIEW_CONVERSATION_STATE_TYPES.includes(message.conversationState.type)) {
    var _dialogueSuffixMap$ma;
    ExpertSuffix = (_dialogueSuffixMap$ma = dialogueSuffixMap.managerView) !== null && _dialogueSuffixMap$ma !== void 0 ? _dialogueSuffixMap$ma : ExpertAvatar;
  } else if (message.conversationState.overrideVoting && REVIEW_ALLOW_REIVEW_DIALOGUE_ORIGIN.includes(dialogue.origin)) {
    ExpertSuffix = ExpertReviewSuffix;
  } else {
    const suffixMap = {
      ...SUFFIX_MAP,
      ...dialogueSuffixMap
    };
    ExpertSuffix = message.conversationState.type !== "dialogueActions" ? suffixMap[message.conversationState.type] : suffixMap["managerView"];
    ExpertDialogueAction = message.conversationState.type === "dialogueActions" && suffixMap[message.conversationState.type];
  }
  return /*#__PURE__*/React.createElement(FadeUp, {
    shouldAnimate: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.responseListContainer
  }, ExpertDialogueAction && /*#__PURE__*/React.createElement("div", {
    className: classes.suffixContainer
  }, /*#__PURE__*/React.createElement(ExpertDialogueAction, _extends({
    dialogue: dialogue,
    message: message
  }, rest))), children, /*#__PURE__*/React.createElement("div", {
    className: `${classes.dialogueNote} ${classes.suffixContainer}`
  }, hasDialogueNote && /*#__PURE__*/React.createElement(DialogueNote, {
    position: "bottom-left",
    note: contentModeratedData
  })), !hasDialogueNote && ExpertSuffix && /*#__PURE__*/React.createElement("div", {
    className: classes.suffixContainer
  }, /*#__PURE__*/React.createElement(ExpertSuffix, _extends({
    dialogue: dialogue,
    message: message
  }, rest)))));
};
const styles = () => ({
  responseListContainer: {
    display: "flex",
    flex: "1",
    flexDirection: "row",
    justifyContent: "flex-end",
    maxWidth: "80%",
    marginLeft: "auto"
  },
  dialogueNote: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  },
  suffixContainer: {
    display: "flex",
    alignItems: "end",
    marginBottom: 25,
    marginLeft: 5
  }
});
export default withStyles(styles)(ExpertDialogueWrapper);
ExpertDialogueWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  dialogue: PropTypes.object.isRequired,
  dialogueSuffixMap: PropTypes.object
};
ExpertDialogueWrapper.defaultProps = {
  dialogueSuffixMap: {}
};